import { getToken } from '@verantos-dev/core-auth';
import { getBaseApiUrl, getGatewayApiVersion } from '@verantos-dev/core-constants';

/**
 * Auth-aware fetch utility for TanStack Query hooks.
 * Mirrors the auth pattern from `createBaseQuery` (RTK Query) but uses
 * plain `fetch` so it works with any data-fetching library.
 *
 * When other domains adopt TanStack Query, promote this to `@verantos-dev/core-utils`.
 */
export async function authFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const baseUrl = `${getBaseApiUrl()}/${getGatewayApiVersion()}`;
  const token = await getToken();

  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }

  // A 204 (e.g. DELETE /analytical-variables/{id}) carries no body.
  if (response.status === 204) {
    return undefined as T;
  }

  return response.json();
}
